<template>
  <div class="user-side-menu">
    <ul>
      <li :class="{ active: page=='editInfo' }"><router-link :to="{ name:'editInfo' }">{{ $t('breadcrumbs.edit_info') }}</router-link></li>
      <li :class="{ active: page=='changePwd' }"><router-link :to="{ name: 'changePwd' }">{{ $t('breadcrumbs.forget') }}</router-link></li>
      <li :class="{ active: page=='customReserveOrder' }"><router-link :to="{ name: 'customReserveOrder' }">{{ $t('breadcrumbs.reserve_order') }}</router-link></li>
      <li :class="{ active: page=='order' }"><router-link :to="{ name: 'order' }">{{ $t('breadcrumbs.order_history') }}</router-link></li>
      <li :class="{ active: page=='customOrder' }"><router-link :to="{ name: 'customOrder' }">{{ $t('breadcrumbs.custom_order') }}</router-link></li>
      <li :class="{ active: page=='favorite' }"><router-link :to="{ name: 'favorite' }">{{ $t('breadcrumbs.favorite') }}</router-link></li>
      <li :class="{ active: page=='newsCenter' }"><router-link :to="{ name: 'newsCenter' }">{{ $t('breadcrumbs.news_center') }}</router-link></li>
      <li :class="{ active: page=='customHistory' }"><router-link :to="{ name: 'customHistory' }">{{ $t('breadcrumbs.custom_history') }}</router-link></li>
      <li :class="{ active: page=='coupon' }"><router-link :to="{ name: 'coupon' }">{{ $t('breadcrumbs.coupon') }}</router-link></li>
      <li :class="{ active: page=='myLink' }"><router-link :to="{ name: 'recommend' }">{{ $t('breadcrumbs.recommend') }}</router-link></li>
      <li @click="logout">{{userInfo ? userInfo.user.name : 's'}} {{ $t('header.logout') }}</li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { del } from "../../utils/localStorage";
  export default {
    name: 'userSideMenu',
    props: ['page'],
    data() {
      return {
        
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    methods: {
      logout(){
        del('token');
        del('userInfo');
        this.$store.commit('CLEAN_USER_INFO');
        this.$router.push({ name: 'register', query: { type: 'login' } });
      }
    }
  }
</script>

<style lang="less" scoped>
.user-side-menu {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-bottom: 15px;
      cursor: pointer;
      a {
        text-decoration: unset;
        color: black;
      }
      &.active {
        a {
          color: #FF5214;
        }
      }
    }
  }
}
</style>